import { useApp } from '@/app/AppContext'
import type { ColumnDescriptor } from './types'
import { columnLabel } from './columnLabel'

/**
 * Настройка колонок списка (ТЗ §5.1).
 *
 * Показываются только те колонки, что вернул сервер: колонка за полевым правом
 * (например, кредитный лимит) до клиента вообще не доезжает. Показать её здесь значило бы
 * предложить настройку, которая молча ничего не даёт, — а выглядит это как сломанный
 * список, а не как отсутствие права.
 */

interface ColumnPickerProps {
  descriptors: ColumnDescriptor[]
  selected: string[]
  onToggle: (column: string) => void
  onReset: () => void
}

export function ColumnPicker({ descriptors, selected, onToggle, onReset }: ColumnPickerProps) {
  const { t } = useApp()

  // Содержимое поповера «Колонки» (кнопка-иконка в тулбаре списка), а не раскрывашка
  // над таблицей: настройка колонок нужна редко и не должна занимать ряд на каждом экране.
  return (
    <div className="column-picker">
      <div className="menu-label">{t('list.columns')}</div>
      <ul className="column-picker-list">
        {descriptors.map((column) => (
          <li key={column.name}>
            <label className="menu-item">
              <input
                type="checkbox"
                checked={selected.includes(column.name)}
                // Последнюю колонку снять нельзя: список без колонок неотличим от
                // сломанного, и вернуть его пользователю нечем.
                disabled={selected.length === 1 && selected.includes(column.name)}
                onChange={() => onToggle(column.name)}
              />
              {columnLabel(t, descriptors, column.name)}
            </label>
          </li>
        ))}
      </ul>
      <div className="menu-sep" />
      <button type="button" className="menu-item" onClick={onReset}>
        {t('list.resetColumns')}
      </button>
    </div>
  )
}
